import { useCallback } from 'react'
import { ChatInputElementId } from '../chat-input-element-id'

export const useFocusChatInput = () => {
  return useCallback(() => {
    const input = document.getElementById(ChatInputElementId)
    if (!input) return
    input.focus()
  }, [])
}

/**
 * Focus plus an `external-focus` event, which the composer uses to tell a
 * programmatic focus apart from the user clicking into it.
 */
export const useExternalFocusChatInput = () => {
  return useCallback(() => {
    const el = document.getElementById(ChatInputElementId)
    if (!el) {
      return
    }
    const focusEvent = new CustomEvent('external-focus', {
      bubbles: true,
    })
    el.dispatchEvent(focusEvent)
    el.focus()
  }, [])
}
